import { POST_FORM_LINK_SUCCESS } from './';

export default payload => dispatch =>
  dispatch({
    type: POST_FORM_LINK_SUCCESS,
    payload,
  });
